import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivateChild, Router, UrlTree} from '@angular/router';
import {Observable} from 'rxjs';
import * as firebase from 'firebase';
import {UserService} from '../services/user.service';
import {ShopService} from '../services/shop.service';
import {AuthService} from "../services/auth.service";

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivateChild {

    lastFailure: string;
    isAuthenticated: boolean;

    constructor(private userService: UserService,
                private shopService: ShopService,
                private router: Router,
                private authService: AuthService) {

      this.authService.getAuthUser().subscribe(authUser => {
        this.isAuthenticated = !!authUser;
        if (this.isAuthenticated && this.lastFailure) {
          router.navigate([this.lastFailure]).then();
          this.lastFailure = null;
        }
      });
      firebase.auth().onAuthStateChanged(authUser => {
        if (authUser && !this.isAuthenticated) {
          this.userService.getUserByEmail(authUser.email).then(user => {
            if (user && user.role !== 'client') {
              if (user) {
                this.isAuthenticated = true;
                console.log('AUTH Guard user', user);
                this.shopService.getShop(user.shopId).then(shop => {
                  if (shop) {
                    this.shopService.setCurrentShop(shop.uid);
                    if (this.lastFailure) {
                      router.navigate([this.lastFailure]).then();
                    }
                  }
                });
              } else {
                this.isAuthenticated = false;
              }
            }
          });
        } else {
          this.isAuthenticated = false;
        }
      });
    }

    canActivateChild(route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      console.log('checking if is logged in');
      if (!this.isAuthenticated) {
        console.log('Guard: not authenticated.', route);
        console.log('route.root.children[0].url[0].path', route.root.children[0].url[0].path);
        this.lastFailure = route.root.children[0].url[0].path;
        this.router.navigate(['login']).then();
        return false;
      }
      this.lastFailure = null;
      return true;
    }
}


